// packages
import React from 'react';
import PropTypes from 'prop-types';
import { Form, FormSpy, Field } from 'react-final-form';
import { Button, FormControl, FormGroup, InputGroup, Well } from 'react-bootstrap';

import './CommonSchedule.less';

const InputField = ({ input, ...rest }) => <FormControl {...input} {...rest} />;

const ScheduleFilters = ({ setViewFilters }) => {
  return (
    <Form
      onSubmit={setViewFilters}
      subscription={{}}
      render={({ handleSubmit, form, submitting }) => (
        <Well>
          <form
            id="filter-schedule-form"
            className="form-inline"
            // trigger filtering on [Enter]
            onSubmit={handleSubmit}
          >
            <FormSpy
              subscription={{
                values: true,
              }}
              onChange={({ values }) => setViewFilters(values)}
            />
            <FormGroup>
              <Field name="keyword" component={InputField} size="30" placeholder="Enter Keywords" /> Amount{' '}
              <InputGroup>
                <InputGroup.Addon>$</InputGroup.Addon>
                <Field
                  name="value_from"
                  component={InputField}
                  step={0.01}
                  type="number"
                  precision={2}
                  size="8"
                  placeholder="0.00"
                />
              </InputGroup>
              {' to '}
              <InputGroup>
                <InputGroup.Addon>$</InputGroup.Addon>
                <Field
                  name="value_to"
                  component={InputField}
                  type="number"
                  step={0.01}
                  precision={2}
                  size="8"
                  placeholder="0.00"
                />
              </InputGroup>
            </FormGroup>{' '}
            <Button type="submit" disabled={submitting} bsStyle="primary">
              <i className="fa fa-search" />
            </Button>
            <Button bsStyle="link" disabled={submitting} onClick={() => form.reset()}>
              clear
            </Button>
          </form>
        </Well>
      )}
    />
  );
};

ScheduleFilters.defaultProps = {
  setViewFilters: () => null,
  viewFilters: {},
  inputRef: {},
  input: {},
};

ScheduleFilters.propTypes = {
  setViewFilters: PropTypes.func,
  viewFilters: PropTypes.object,
  input: PropTypes.object,
  inputRef: PropTypes.object,
};
export default ScheduleFilters;



// WEBPACK FOOTER //
// ./src/scheduleform/common/ScheduleFilters.jsx